// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + ".3a48617eb3a48cb0995f5f70e2ea5f6d.js";
};